import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import {
	adminSearchShardCatalogReducers,
	adminSearchShardCatalogWatchers } from './shard-catalog';

export const adminSearchReducers = combineReducers({
	shardCatalog: adminSearchShardCatalogReducers
});

export const adminSearchWatchers = combineAllWatchers([
	adminSearchShardCatalogWatchers
]);
